// TeamData.js

const teamData = [
  {
    name: 'Bhogi Sumasri',
    rollNumber: '20VV1A1208',
    year: '2023-2024',
    role: 'Team Member',
    linkedin: '',
    github: '',
    instagram: '',
    email: '',
    website: '',
  },

  {
    name: 'Bontalakoti Saikiran',
    rollNumber: '20VV1A1211',
    year: '2023-2024',
    role: 'Team Member',
    linkedin: '',
    github: '',
    instagram: '',
    email: '',
    website: '',
  },
  {
    name: 'Shaik Vali Basha',
    rollNumber: '20VV1A1257',
    year: '2023-2024',
    role: 'Team Member',
    linkedin: '',
    github: '',
    instagram: '',
    email: '',
    website: '',
  },
  {
    name: 'Uppala Kirtana',
    rollNumber: '20VV1A1261',
    year: '2023-2024',
    role: 'Team Member',
    linkedin: '',
    github: '',
    instagram: '',
    email: '',
    website: '',
  },
  {
    name: 'Anil Sinthu',
    rollNumber: '22VV5A1273',
    year: '2024-2025',
    role: 'Full Stack Developer',
    linkedin: 'https://www.linkedin.com/in/anilsinthu',
    github: 'https://github.com/anilsinthu73',
    instagram: 'https://www.instagram.com/mr.anil_sinthu/',
    email: 'mailto:anilsinthu114@gmail.com',
    website: 'https://anilsinthu.vercel.app/',
    about: "Spearheaded the V3.0 Academic Premium UI/UX restructuring for the JNTU-GV web portal, ensuring UGC compliance and enforcing strict security access. Consistently delivering robust, highly available architectures for digital governance.",
    contributions: [
      "Engineered the responsive, glassmorphic layout and integrated modern aesthetic components.",
      "Architected the dynamic hierarchical navigation logic prioritizing mobile-first rendering.",
      "Optimized load times and asset caching methodologies across the deployed Vercel platforms.",
      "Served as key implementation lead for the University's mandatory UGC Disclosures portal integration."
    ],
    skills: ["React.js", "Node.js", "User Interface Design", "Next.js", "Vercel / CI-CD", "TailwindCSS"]
  },
  {
    name: 'Harsha Vivek',
    rollNumber: '21VV1A1203',
    year: '2024-2025',
    role: 'Front End Developer',
    linkedin: 'https://www.linkedin.com/in/harsha-vivek-',
    github: '',
    instagram: '',
    email: '',
    website: '',
  }
];

export default teamData;
